/* src/app/pages/casos/verformtratamiento/verformtratamiento.component.scss */
/*# sourceMappingURL=verformtratamiento.component.css.map */
